import React from 'react'
import {Link} from 'gatsby'	



export default function Info() {	
  return (	
    <section className="py-5">	
      <div className="container">	
      <div className="row">	
      <div className="col-10 col-sm-8 mx-auto text-center">	
      <p className="lead text-muted mb-5">	
      Caffe Pietro is the brainchild of Italian entrepreneur that wanted nothing more than to bring a little slice of the real Italy to Chicago. Caffe Pietro first opened its doors to the public in 2001.	
      </p>	
     
      
      </div>	
      </div>	
    </div>	
    </section>	
  );	
}